/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm } from 'framework/form';
import EmployeeAssignmentForm from '../EmployeeAssignmentForm';
import {
  useEmployeeAssignmentId,
  useEmployeeAssignmentUrl,
} from 'domain/people/employee/assignments/assignmentRouting';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import { AssignmentType, useAssignmentService } from 'domain/shared/assignment';

const CreateEmployeeAssignment = () => {
  const { getListUrl } = useEmployeeAssignmentUrl();
  const { create, getValidationSchema, getAssignmentById } = useAssignmentService();
  const employeeId = useEmployeeId();
  const id = useEmployeeAssignmentId();
  let getDataFunc;

  if (id) {
    getDataFunc = () => getAssignmentById(id);
  }

  return (
    <CreateForm
      submitFormFunc={create}
      getDataFunc={getDataFunc}
      initialData={{
        employeeId,
        assignmentType: AssignmentType.INDIVIDUAL_ASSIGNMENT,
      }}
      afterSubmit={{
        redirect: getListUrl(),
        message: 'You are awesome! The Assignment has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
    >
      <CreatePageLayout title="Create: Assignment" titleVariant="h4">
        <EmployeeAssignmentForm isCreateForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateEmployeeAssignment;
